import * as types from './types';

export const openSnackbar = payload => ({
  type: types.OPEN_SNACKBAR,
  payload,
});

export const closeSnackbar = () => ({
  type: types.CLOSE_SNACKBAR,
});



// WEBPACK FOOTER //
// ./src/redux/snackbar/actions.js